<template>
  <div id="printTable">
    <Form ref="formDynamic" :model="formDynamic" :label-width="50">
      <List border size="small" style="color: black">
        <!-- <ListItem>
          <Col span="3">采购工单编号:</Col>
          <Col span="10">{{ procurementNum }}</Col>
        </ListItem> -->
        <ListItem>
          <Col span="3">事由:</Col>
          <Col span="10">
            <Input placeholder="请输入事由" v-model="shiyou"></Input>
          </Col>
        </ListItem>
        <ListItem>
          <Col span="3">期望交付日期:</Col>
          <Col span="10">
            <DatePicker
              :options="options"
              type="date"
              placeholder="选择日期"
              v-model="jiaofuData"
              format="yyyy-MM-dd"
            >
            </DatePicker>
          </Col>
        </ListItem>
        <ListItem>
          <Col span="3">收货信息:</Col>
          <Col span="10">
            <Input
              v-model="shouhuoInfo"
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 3 }"
            ></Input>
          </Col>
        </ListItem>
      </List>
      <!-- 表格 -->
      <h4 style="margin: 10px 0; color: black">明细:</h4>
      <Row>
        <Table
          :columns="tableCols"
          :data="data2"
          :table="table"
          :border="table.border"
          :stripe="table.stripe"
          :header="table.header"
          :footer="table.footer"
          :columns-list="tableCols"
        >
        </Table>
      </Row>
      <Row style="margin-top: 5px">
        <Col>
          <h3 class="zong">总价:{{ zongjia }}元</h3>
        </Col>
      </Row>
      <Row style="margin: 5px 0">
        <Col span="3">
          <h3 class="zong" style="display: inline">优惠后总价:</h3>
        </Col>
        <Col span="10">
          <InputNumber :min="0" v-model="endTotalPrice" />
        </Col>
      </Row>
      <Row style="margin: 5px 0">
        <Col span="3">
          <h3 style="color: black" v-if="this.customerId != 0">选择供应商:</h3>
          <h3 style="color: black" v-if="this.customerId == 0">选择客户:</h3>
        </Col>
        <Col span="10">
          <Select v-model="model" filterable @on-change="handleSelect">
            <Option v-for="item in cityList" :value="item.value" :key="item.value">{{
              item.label
            }}</Option>
          </Select>
        </Col>
      </Row>
      <Row>
        <Col span="3">
          <h4 style="margin-bottom: 5px; color: black">备注:</h4>
        </Col>
        <Col span="10"
          ><Input
            v-model="procurementOpinions"
            type="textarea"
            :autosize="{ minRows: 1, maxRows: 2 }"
          ></Input>
        </Col>
      </Row>

      <Button style="margin-top: 10px" type="primary" @click="handleSubmit()"
        >提交</Button
      >
    </Form>
  </div>
</template>
<script>
import { IMAGE_HOST } from "@/../config";
import dayjs from "dayjs";

let customerId = window.localStorage.getItem("customerId");
export default {
  props: {
    consumableInventory: [],
    id: null,
  },
  data() {
    return {
      customerId: "",
      model: "",
      cityList: [],
      endTotalPrice: 0,
      procurementNum: "后台自动生成",
      zongjia: 0,
      id: null,
      procurementOpinions: "",
      options: {
        disabledDate: function (date) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          const checkDate = new Date(date);
          return checkDate < today;
        },
      },
      shiyou: "",
      jiaofuData: "",
      shouhuoInfo: "",
      table: {
        mname: "consumables",
        key: "id",
        border: true,
        rows: [],
        stripe: true,
        header: false,
        footer: false,
        order: "",
        router: {
          add: "",
          edit: "",
        },
      },
      formDynamic: {},
      index: 1,
      desk: "",
      receive: "",
      data2: [],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 65,
          align: "center",
        },
        {
          title: "货物信息",
          width: 485,
          align: "center",
          render: (h, p) => {
            return h(
              "div",
              {
                style: {
                  height: "80px",
                  display: "flex",
                  justifyContent: "flex-start",
                },
              },
              [
                h("img", {
                  style: {
                    width: "60px",
                    height: "60px",
                    margin: "10px",
                  },
                  attrs: { src: IMAGE_HOST + p.row.consumableImgUrl },
                }),
                h("div", [
                  h(
                    "p",
                    {
                      style: {
                        marginTop: "10px",
                        textAlign: "left",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      },
                      domProps: {
                        title: p.row.brand + p.row.name,
                      },
                    },
                    p.row.brand + p.row.name
                  ),
                  h(
                    "p",
                    {
                      style: {
                        textAlign: "left",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: p.row.model == null ? "none" : "block",
                      },
                      domProps: {
                        title: "型号:" + p.row.model,
                      },
                    },
                    "型  号: " + p.row.model
                  ),
                  h(
                    "p",
                    {
                      style: {
                        width: "350px",
                        textAlign: "left",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: p.row.remark == null ? "none" : "block",
                      },
                      domProps: {
                        title: "适用于: " + p.row.remark,
                      },
                    },
                    "适用于: " + p.row.remark
                  ),
                ]),
              ]
            );
          },
        },
        {
          title: "库存",
          key: "num",
          minWidth: 85,
          align: "center",
        },
        {
          title: "单位",
          key: "unit",
          minWidth: 65,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.unit;
            return <span style={{ "font-size": "14px" }} >{text}</span>;
          },
        },
        {
          title: "单价/元",
          key: "unitPrice",
          minWidth: 85,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.unitPrice;
            return <span style={{ "font-size": "14px" }} >{text}</span>;
          },
        },
        {
          title: "采购数量",
          key: "alterNum",
          minWidth: 120,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            return <span style={{ "font-size": "14px" }} >{row.alterNum}</span>;
          },
        },
      ],
      supplierId: 0,
    };
  },
  async created() {
    let id = this.id;
    if (id) {
      this.id = id;
      this.initData();
    }
    this.customerId = customerId;
    this.supplierData();
  },
  methods: {
    handleSelect(v) {
      this.supplierId = v;
    },
    // 加载供应商数据
    supplierData() {
      $utils.api.load(`/admin/system/supplier/list`, {}).then((res) => {
        if (res && res.rows) {
          let data = res.rows;
          data.map((item, index) => {
            let obj = {};
            obj.value = item.id;
            obj.label = item.supplierName;
            this.cityList.push(obj);
          });
        }
      });
    },
    initData() {
      // 加载详情工单数据
      let id = this.id;
      $utils.api.load(`/admin/system/inventory/${id}`, {}).then((res) => {
        if (res && res.data) {
          let data = res.data;
          this.consumableInventory = data.sysConsumableReceiveDetails;
          for (let i = 0; i < this.consumableInventory.length; i++) {
            let consumableIn = {};
            let item = this.consumableInventory[i];
            consumableIn.inventoryId = item.inventoryId;
            consumableIn.consumableImgUrl = item.consumableImgUrl
              ? item.consumableImgUrl
              : "src\assets\logo.min.png";
            consumableIn.brand = item.brand;
            consumableIn.name = item.inventoryName;
            consumableIn.model = item.model;
            consumableIn.remark = item.remark;
            consumableIn.unit = item.unit;
            consumableIn.alterNum = item.alterNum;
            consumableIn.num = item.num;
            consumableIn.unitPrice = item.unitPrice == null ? 0 : item.unitPrice;
            this.data2.push(consumableIn);
          }
          this.getzongjia(this.data2);
        }
      });
    },
    getzongjia(list) {
      this.zongjia = list.reduce((accumulator, item) => {
        const num = Number(item.alterNum || 0);
        const price = Number(item.unitPrice || 0);
        return accumulator + price * num;
      }, 0);
      this.zongjia = this.zongjia.toFixed(2);
    },
    async handleSubmit() {
      let customerId = window.localStorage.getItem("customerId");
      let time = dayjs().format("YYYY-MM-DD HH:mm:ss");
      let q = {
        cause: this.shiyou, //事由
        deliveryDate: dayjs(this.jiaofuData).format("YYYY-MM-DD"), // 期望交付日期
        totalPrices: this.zongjia, //总价
        remark: this.procurementOpinions, //备注
        discountsPrices: this.endTotalPrice, //优惠后总价
        supplierId: this.supplierId, //供应商id,
        customerId: customerId,
        isFillInLogistics: 1, //是否填写物流信息(1.未填写
        purchaseTime: time,
        receiveId: this.id,
        state: 1,
        goodsReceivingInformation: this.shouhuoInfo,
      };
      console.log(q);
      let res = await $utils.api.load("/admin/system/receive/addPurchase", q, "post");
      if (res.code == 200) {
        $utils.toast.success("提交成功");
        this.$Modal.remove();
        setTimeout(() => {
          $utils.url.go(0);
        }, 1000);
      } else {
        $utils.toast.error(res.message);
      }
    },
    handleRemove(index) {
      this.formDynamic.items[index].status = 0;
    },
  },
};
</script>
<style scoped>
.zong {
  color: black;
}
</style>
